import { RingProgress, ThemeIcon } from '@mantine/core';

import { IconCheck } from '@tabler/icons-react';

export type CompletionRingStatus = 'in_progress' | 'pending_approval' | 'approved';

export interface CompletionRingViewProps {
  percentage: number;
  status: CompletionRingStatus;
  size?: number;
  onClick?: () => void;
}

const STATUS_COLOR: Record<CompletionRingStatus, string> = {
  in_progress: 'var(--mantine-color-brand-6)',
  pending_approval: 'var(--mantine-color-orange-6)',
  approved: 'var(--mantine-color-teal-6)',
};

export function CompletionRingView({
  percentage,
  status,
  size = 28,
  onClick,
}: CompletionRingViewProps) {
  const isDone = status === 'approved' && percentage >= 100;
  const style = { cursor: onClick ? 'pointer' : undefined, flexShrink: 0 };

  if (isDone) {
    return (
      <ThemeIcon
        color="teal"
        radius="xl"
        size={size}
        variant="filled"
        onClick={onClick}
        style={style}
      >
        <IconCheck size={size * 0.6} stroke={3} />
      </ThemeIcon>
    );
  }

  return (
    <RingProgress
      size={size}
      thickness={3}
      roundCaps
      sections={[{ value: percentage, color: STATUS_COLOR[status] }]}
      onClick={onClick}
      style={style}
    />
  );
}
